/**
 * @module app.kya.list.deleteContractCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function DeleteContractCtrl($scope, $uibModalInstance, $log) {
        var self = {};

        self.delete = function() {
            $uibModalInstance.close(true);
        };

        self.doNotDelete = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    DeleteContractCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular
        .module('app.kya.list.deleteContractCtrl', ['ui.bootstrap.modal'])
        .controller('DeleteContractCtrl', DeleteContractCtrl);
});
